import React from 'react';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import { Link } from 'react-router-dom';

/* eslint-disable react/prop-types */
const customersActions = ({ permissions, settings, openAccountWithholdingModal, openCustomerImyFormsModal }) => ({
  id: 'action-column',
  Header: <span className="expand-header-offset">View</span>,
  Cell: ({ row }) => (
    <div className="form-action-btn-group">
      <Link to={ `/customer/${ row.original.itemId }` }>
        <button
          type="button"
          className="btn btn-sm btn-sm"
          title="Customer Details"
        >
          <span className="icon icon-apps" />
        </button>
      </Link>
      { (settings && settings.showWithholding && AccessControl.hasPermission(permissions, [ActivityPerms.whdViewRates]))
        && row.original.accountNumber && row.original.accountNumber !== 'N/A'
              && ((row.original.isDirect === 'Yes' && !row.original.hasImyStructure) || !row.original.formExpectsWhs)
        && <button
          className="btn btn-sm "
          type="button"
          onClick={ () => openAccountWithholdingModal(row.original, 'customers') }
          title="Show Withholding Rates"
        >
          <span className="icon icon-calculator" />
        </button> }
      { (AccessControl.hasPermission(permissions, [ActivityPerms.scannedViewTree]))
        && ((row.original.isDirect === 'No' && row.original.whsWithinEffectiveRange === true)
              || row.original.hasPublishedWhs || (row.original.hasImyStructure && row.original.formExpectsWhs))
        && <button
          className="btn btn-sm "
          type="button"
          onClick={ () => openCustomerImyFormsModal(row.original) }
          title="Show IMY linked forms"
        >
          <span className="icon icon-treeview" />
        </button> }
    </div>
  )
});
/* eslint-enable react/prop-types */

export default customersActions;
